import React, { useEffect, useState } from 'react';
import { Box, Title, SubTitle, Text, Button, Space, MenuItem, SiteTitle, Socials, Social } from '../theme/theme';
import MetaTags from 'react-meta-tags';
import { useSelector } from 'react-redux';
import Spinner from '../components/spinner';
import { Container, Grid, Typography } from '@mui/material';
import BlockContent from '@sanity/block-content-to-react'

import settings from "../settings.json"
import { Link } from 'react-router-dom';
import { AvatarList } from '../components/avatar';
import CollapsibleContainer from '../components/collapsibleContainer';

import { LuTestTube2 } from "react-icons/lu";


// TODO: implement

const SiteBuilder = ()=>{
    // const client = useSelector(state=>state.data.client);
    // const members = useSelector(state=>state.data.members);
    // const graphics = useSelector(state=>state.data.graphics)
    // const settings = useSelector(state=>state.data.settings)
    // const collaborators = useSelector(state=>state.data.collaborators)

    useEffect(()=>{
        // if (!data && client){
        //     client.getHome()
        //     .then(newdata=>setData(newdata));
        // }
    })

    const Meta = <MetaTags>
                    <title>{"Pieter Steyaert / Home"}</title>
                    <meta name="description" content={"Pieter is an artist and researcher based in Copenhagen, Denmark, working at the intersection of art and science. He co-founded the collective SEADS, known for community art projects like Biomodd. Pieter is involved in projects such as sending an evolutionary artwork into space and co-directing immersive theatre experiences. He also develops online platforms, creates software for live visual performances, and is pursuing a PhD in facilitating collaborations between arts and sciences."} />
                    <meta property="og:title" content={"Pieter Steyaert / Home"} />
                </MetaTags>

    if (false){
        return "Data missing - see console"
    } else {
        return <div>
            <Title>ARTIFEX TITLE</Title>
            

            <SiteTitle>ARTIFEX</SiteTitle>
            <Title>I am a title</Title>
            <SubTitle>I am a subtitle</SubTitle>
            <Text>I am just regular old text</Text>
            <MenuItem>I am a menuitem</MenuItem>
            <Social>I am social</Social>

            <CollapsibleContainer open title="I am title"  icon={<LuTestTube2 />} >I am text inside the container</CollapsibleContainer>
            
            
            <br/><br/><br/><br/><br/>


    </div>
    
    }

    
    
    // if (!data || !members){
    //     return <>
    //             {Meta}
    //             <Spinner />
    //         </>
    // } else {
    
    return "builder"
}



export default SiteBuilder;
